import { ContainerComponent, wrap, Wrapper } from 'AppReact';
import styled from 'styled-components';
import { FlexCenterWrapper } from 'wrappers';
import { AchievementElement } from 'molecules';
import { MarginLeftWrapper } from './wrappers';
import controller from './controller';
import internalState from './internalState';
import getIsMobile from 'components/atoms/utils/getIsMobile';

const isMobile = getIsMobile();

export const definition = {
  name: "Achievements",
  controller: controller,
  initialProps: ({ stats, clickable, selected }) => ({ stats, clickable, selected }),
  props: internalState,
  elements: [
    {
      wrapper: Wrapper(styled.div`display: flex; flex-direction: column; column-count: 2;`),
      name: 'LeftAssignments',
      elements: [
        {
          component: AchievementElement,
          name: 'Completed',
          displayState: ({ selected }) => ({ selected: selected === 'completed' }),
          bindings: ({ stats, clickable }) => ({ clickable, count: stats?.completed || 0, name: "COMPLETED", color: '#1DBD6B' }),
          displayState: ({ clickable }) => ({ clickable })
        },
        {
          component: wrap(AchievementElement, Wrapper(styled.div`margin-top: 12px;`)),
          name: 'Callbacks',
          displayState: ({ selected }) => ({ selected: selected === 'callback' }),
          bindings: ({ stats, clickable }) => ({ clickable, count: stats?.callbacks || stats?.callback || 0, name: "CALLBACKS", color: "#FFC700" }),
          displayState: ({ clickable }) => ({ clickable })
        },
      ]
    },
    {
      wrapper: MarginLeftWrapper,
      name: 'RightAssignments',
      elements: [
        {
          component: wrap(AchievementElement, Wrapper(styled.div`margin-top: ${isMobile ? '-40px' : '-48px;'}`)),
          name: 'Assigned',
          displayState: ({ selected }) => ({ selected: selected === 'assigned' }),
          bindings: ({ stats, clickable }) => ({ clickable, count: stats?.assigned || 0, name: "ASSIGNED", color: "#6457E8" }),
          displayState: ({ clickable }) => ({ clickable })
        }
      ]
    },
  ]
}

const Achievements = ContainerComponent(definition)

export default wrap(Achievements, FlexCenterWrapper)
